// API result code
export const API_RESULT_CODE = {
  SUCCESS: 'S',
  FAIL: 'F',
} as const;

export const HEADERS_JSON = {
  headers: {
    'Content-Type': 'application/json',
  },
};
export const HEADERS_FORMDATA = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
};
export const HEADERS_MULTIPART = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};
